import { Component, Inject, OnInit } from '@angular/core';
import { IMachineState } from 'app/models';
import { DataStateService } from 'app/services';
import { take } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-error-list-popup',
  templateUrl: './error-list-popup.component.html',
  styleUrls: ['./error-list-popup.component.scss'],
})
export class ErrorListPopupComponent implements OnInit {
  customerId: number | null = null;
  machineId: number | null = null;
  machineName: string | null = null;
  from: Date | null = null;
  to: Date | null = null;
  fromFormatted: string | null = null;
  toFormatted: string | null = null;

  errorList: IMachineState[] = [];

  constructor(
    public dialogRef: MatDialogRef<ErrorListPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorListPopupModel,
    private readonly dataStateService: DataStateService,
  ) {
    this.customerId = data.customerId;
    this.machineId = data.machineId;
    this.machineName = data.machineName;
    this.from = data.from;
    this.to = data.to;
    this.fromFormatted = data.from.toLocaleDateString();
    this.toFormatted = data.to.toLocaleDateString();
  }

  ngOnInit(): void {
    this.dataStateService.getAllMachineStates(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.customerId!!,
      this.machineId || undefined,
      undefined,
      this.from || undefined,
      this.to || undefined,
      'ERR'
    )
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.errorList = data;
        },
        (error) => console.log(error)
      );
  }
}

export class ErrorListPopupModel {
  constructor(
    public customerId: number,
    public machineId: number,
    public machineName: string,
    public from: Date,
    public to: Date,
  ) { }
}
